export default "/images/local_foods_provided_sm.jpg?313a2213e3ff8be284c0404d50109479";